<template>
  <div>
    <select class="common_select" @change="onChange">
      <option v-for="(item, n) in items" :key="n" :value="item.value" :selected="item.selected">
        {{ item.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { SEMESTERS } from "@/common/define";

export default {
  name: "SelectSemester",
  props: {
    value: String,
  },
  data: () => ({
    items: [],
  }),
  computed: {
  },
  methods: {
    onChange(evt) {
      this.items.forEach((item, i) => {
         item.selected = i === evt.srcElement.selectedIndex ? true : false;
      });
      let selected = this.items.filter((item) => {
        return item.selected;
      });
      this.$emit("input", selected[0].value);
    },
  },
  beforeMount() {
    let me = this;
    Object.entries(SEMESTERS).forEach((item) => {
      this.items.push({
        name: this.$i18n.translate(item[1]),
        value: item[0]
      });
    });
    this.items.forEach((item) => {
      item.selected = (item.value === me.value ? true : false);
    });
  },
}
</script>
